import ExpenseLine from "./ExpenseLine/ExpenseLine";
import { useExpenses } from "../../contexts/expenses.context";
import { useDashboard } from "../../contexts/dashboard.context";
import axios from "axios";

const Expenses = () => {
  const Expenses = useExpenses();
  const { page } = useDashboard();

  const handleRemoveExpense = async (name: string, userId: string) => {
    Expenses.removeExpense(name);
    await axios.delete(`http://localhost:5000/api/deleteExpense`, {
      params: {
        name: name,
        userId: userId,
      },
    });
  };

  return (
    <>
      {page === "Expenses" ? (
        <div className="flex flex-col rounded-md shadow-md">
          {Expenses.expenses.map(({ name, value, userId }) => (
            <>
              <ExpenseLine
                key={name}
                text={name}
                value={value}
                handleRemoveLine={() => handleRemoveExpense(name, userId)}
              />
              <hr className="mx-8 last:hidden border-almost-white" />
            </>
          ))}
        </div>
      ) : undefined}
    </>
  );
};

export default Expenses;
